import { createContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [customerResData, setCustomerResData] = useState(null);
  const [zohoCRMData, setZohoCRMData] = useState(null);
  const [currentSideTab, setCurrentSideTab] = useState("customers");
  /** AccountUserInfo.adminUser from GET /session (0 if unknown). */
  const [adminToolAccountUserRole, setAdminToolAccountUserRole] = useState(0);
  return (
    <AuthContext.Provider
      value={{
        isAdmin,
        setIsAdmin,
        currentSideTab,
        setCurrentSideTab,
        customerResData,
        setCustomerResData,
        zohoCRMData,
        setZohoCRMData,
        adminToolAccountUserRole,
        setAdminToolAccountUserRole,
        }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
